import { FiltersFeature } from 'features/Filters'
import { InitFeature } from 'features/Init'
import { LayoutFeature } from 'features/Layout'
import { StandingsFeature } from 'features/Standings'
import { IFeature } from 'types'

export const appFeatures: IFeature[] = [
  InitFeature,
  LayoutFeature,
  FiltersFeature,
  StandingsFeature,
]
